import {useFormContext} from "react-hook-form";

const dohvatiVrijednostPolja = (obj: any, path: any) =>
    path
        .replace(/\[|\]\.?/g, '.')
        .split('.')
        .filter((s: any) => s)
        .reduce((acc: any, val: any) => acc && acc[val], obj);

export default dohvatiVrijednostPolja;